module.exports = __webpack_public_path__ + "media/images/top/common/img_step01-37b4a196501656b4276061c77fb97015.png";